import React, {Component} from 'react';
import Modal from 'react-modal';
import REST from "../Shared/REST";
import DialogBox from "../Shared/DialogBox";

Modal.setAppElement('body');

const customStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '50%'
    }
};

class EmailConsentForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            done: false,
            submitting: false,
            isOpen: false,
            downloadCliced:false,
            checkboxChecked:false,
            agreeChecked:false,
            email:"",
            modalDialog: false,
            responseContent:''
        };

        this.submitForm = this.submitForm.bind(this);
        this.downloadClicked = this.downloadClicked.bind(this);
        this.handleCheckBox = this.handleCheckBox.bind(this);
        this.handleAgreeChecked = this.handleAgreeChecked.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount(){
        this.setState({
            isOpen : !this.props.teacher.teacher.consent
        });
    }

    downloadClicked(){
        this.setState({
            downloadClicked: true
        })
    }

    handleCheckBox(e){
        this.setState({
            checkboxChecked:e.target.checked
        });
    }

    handleAgreeChecked(e){
        this.setState({
            agreeChecked:e.target.checked
        });
    }

    handleEmailChange(e){
        this.setState({
            email:e.target.value
        });
    }

    handleClose(){
        this.setState({modalDialog: false});
        if(this.state.responseContent==="Your consent has been recorded."){
            this.props.updateTeacher({
                ...this.props.teacher,
                teacher: {
                    ...this.props.teacher.teacher,
                    consent: true
                }
            });
            this.setState({
                isOpen: false
            });
        }
    }

    async submitForm() {

        if(!this.state.agreeChecked){
            this.setState({
                modalDialog: true,
                responseContent:"Please check the 'I agree' checkbox."

            });
        }else {
            this.setState({
                submitting: true
            });
            let data = {
                email: this.state.email,
            };

            await REST.teacherConsent(data).then(res => {
                this.setState({
                    done: true,
                    submitting: false
                });
                this.setState({
                    modalDialog: true,
                    responseContent:"Your consent has been recorded."

                });

            }).catch(err => {
                console.log(err);
                this.setState({
                    done: true,
                    submitting: false
                });
                this.setState({
                    modalDialog: true,
                    responseContent:"An error occurred, please try again."

                });
            });
        }

    }

    render() {

        return (
            <Modal isOpen={this.state.isOpen} style={customStyle}>
                <div className="modal-content content">
                    <div className="modal-header">
                        <div className="clearfix"></div>
                        <h2>Consent Form</h2>
                    </div>
                    <div className={"modal-body"}>
                        <div className="row">
                            <div className="col-md-12 bgGrey roundCorners">
                                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={this.handleClose} />
                                <form className="form">
                                    <br/>
                                    <h4>Please download and read the document below.</h4>
                                    <a onClick={this.downloadClicked} href={"https://api-beta.avepm.com/documents/Consent_teachers.docx"} className="handBtn" type="submit"><span>Download</span></a>
                                    <h4>May we contact you to ask for feedback (select the checkbox) ?</h4>
                                    <div style={{float:'left', marginLeft: 50, width: 100}}>
                                    <input
                                        name="Checkbox"
                                        type="checkbox"
                                        checked={this.state.checkboxChecked}
                                        onChange={this.handleCheckBox}/>
                                    </div>
                                    <div hidden={!this.state.checkboxChecked}>
                                    <h4>Email Address</h4>
                                    <input onChange={this.handleEmailChange} type="email"
                                           className="form-control" placeholder="Email Address" required/>
                                    </div>
                                    <br/>
                                    <h4>By checking the checkbox below you are acknowledging that you have read the consent document and you agree to participate.</h4>
                                    <h4 style={{float:'left', width: 100}}>I agree</h4>
                                    <div style={{float:'left', marginLeft: -50, marginTop:10, width: 100}}>
                                    <input
                                        name="Checkbox"
                                        type="checkbox"
                                        checked={this.state.agreeChecked}
                                        onChange={this.handleAgreeChecked}/>
                                    </div>
                                    <br/>
                                    <br/>
                                    <div style={{marginLeft:'auto', marginRight:'auto', width:150}}>
                                        <a href={"https://uploadbeta.s3.us-east-2.amazonaws.com/documents/ApplicationPrivacyStatement.pdf"} target="_blank">Privacy Statement</a>
                                    </div>
                                    <br/>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <a onClick={this.submitForm}
                           className="handBtn" type="submit"><span>Done</span></a>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default EmailConsentForm;



// WEBPACK FOOTER //
// ./src/ModalFormComponents/EmailConsentForm.js